exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".chat-searching-wraper .progress{height:10px;margin-top:20px}.chat-searching-offer-wraper{margin:30px 0}.progress-bar,.progress-bar-striped{background-color:#313131!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/sass-loader/dist/cjs.js!./components/chat/styles/searchingForAgent.scss
// module id = 1169
// module chunks = 0 1